/**
 * Stakeholder fixture (Sprint 4.3.8).
 *
 * Eight sample stakeholders covering each role + tier permutation
 * referenced in the sprint brief. Names anchor in the existing
 * synthetic-clinicians + Phase B `stakeholder-model.md` examples (Khalid
 * Al-Mansoori cardiometabolic + Fatima Al-Zaabi HRT pathways).
 *
 * HC1 reproducibility: ids are stable slugs.
 * HC5: zero em / en dashes.
 */
import type { Stakeholder } from '../types/stakeholder';

export const STAKEHOLDER_FIXTURES: ReadonlyArray<Stakeholder> = [
  {
    id: 'dr-aldhaheri',
    name: 'Dr. Al-Dhaheri',
    role: 'physician',
    tier: 'clinical-decision',
    description:
      'Cardiologist of record. Approves enrollment gates and signs off on tier-1 NBA recommendations.',
    incompatibleWith: ['coach'],
  },
  {
    id: 'nurse-fatima',
    name: 'Nurse Fatima',
    role: 'nurse',
    tier: 'clinical-decision',
    description:
      'Primary care-team nurse. Executes lab dispatch and patient outreach actions.',
  },
  {
    id: 'coach-omar',
    name: 'Coach Omar',
    role: 'coach',
    tier: 'supervisory',
    description:
      'Lifestyle coach. Supports the 16 week program with weekly check-ins.',
    incompatibleWith: ['physician'],
  },
  {
    id: 'pharmacist-saeed',
    name: 'Pharmacist Saeed',
    role: 'pharmacist',
    tier: 'clinical-decision',
    description:
      'Pharmacy lead. Reviews GLP-1 dispense requests and reconciles formulary coverage.',
  },
  {
    id: 'cm-khalid',
    name: 'Care Coordinator Khalid',
    role: 'care-coordinator',
    tier: 'supervisory',
    description:
      'Patient navigator. Schedules visits and coordinates between cardiology and pharmacy.',
  },
  {
    id: 'therapist-mariam',
    name: 'Therapist Mariam',
    role: 'therapist',
    tier: 'supervisory',
    description:
      'Behavioural therapist. Supports adherence and lifestyle modification check-ins.',
  },
  {
    id: 'sw-aisha',
    name: 'Social Worker Aisha',
    role: 'social-worker',
    tier: 'read-only',
    description:
      'Reviews social determinants and surfaces benefits routing. No clinical write authority.',
  },
  {
    id: 'patient-self',
    name: 'Patient',
    role: 'patient',
    tier: 'read-only',
    description:
      'Patient stakeholder. Activities assigned here render in the patient-facing surface.',
  },
];
